import Masker from 'vue-the-mask/src/masker'
import Tokens from 'vue-the-mask/src/tokens'

import PaisConstantes from '@/constants/corporativo/pais'
import DocumentoConstantes from '@/constants/corporativo/documento'

import DocumentoApi from '@/api/workspace/corporativo/documento'
import FormMixin from '@/mixin/form'
import { mapGetters , mapMutations } from 'vuex'

export default {
    mixins: [ FormMixin ],     
    data() {
        return {
            debounce: null 
        }
    },
    computed:{
        ...mapGetters("app", ["getDocuments"]),
    },
    async created(){
        this.debounce = this.$_.debounce(async () => await this.listarDocumento(), 1000);    
        if((this.getDocuments || []).length == 0) 
            await this.debounce();
    },
    beforeDestroy(){
        this.debounce.cancel();
    },     
    methods: {
        ...mapMutations("app", ["setDocuments"]),
        async listarDocumento(){
            this.setLoaderQueue(this.uniqueId);        
            const documento = await DocumentoApi.listar().catch(erro => this.showSnackbarError(erro.error));   

            if(documento.success) 
                this.setDocuments(documento.data);

            else {                        
                this.showSnackbarError(documento.error);
                throw new Error(documento.error[0].userMessage);
            }

            this.unsetLoaderQueue(this.uniqueId);    
        },            
        retornarAtributoDocumentoPrincipal(pais) {
            let documento = null;
            let atributo = null;

            if(pais == null || (this.getDocuments || []).length == 0) 
                return atributo;
            
            switch(pais.codigoSuccessFactors){
                case PaisConstantes.brasil.codigo:
                    documento = this.getDocuments.filter(d => d.codigoUnico == DocumentoConstantes.brasil.cadastroPessoaFisica.codigo);
                    if(documento.length > 0) atributo = documento[0].atributo.filter(a => a.codigoUnico == DocumentoConstantes.brasil.cadastroPessoaFisica.atributo.id);

                    break;

                case PaisConstantes.colombia.codigo:
                    documento = this.getDocuments.filter(d => d.codigoUnico == DocumentoConstantes.colombia.cedulaIdentidade.codigo);
                    if(documento.length > 0) atributo = documento[0].atributo.filter(a => a.codigoUnico == DocumentoConstantes.colombia.cedulaIdentidade.atributo.id);                 

                    break;
                    
                case PaisConstantes.chile.codigo:
                    documento = this.getDocuments.filter(d => d.codigoUnico == DocumentoConstantes.chile.cedulaIdentidade.codigo);
                    if(documento.length > 0) atributo = documento[0].atributo.filter(a => a.codigoUnico == DocumentoConstantes.chile.cedulaIdentidade.atributo.id);                           

                    break;                 
                    
                case PaisConstantes.argentina.codigo:
                    documento = this.getDocuments.filter(d => d.codigoUnico == DocumentoConstantes.argentina.documentoNacionalIdentidade.codigo);
                    if(documento.length > 0) atributo = documento[0].atributo.filter(a => a.codigoUnico == DocumentoConstantes.argentina.documentoNacionalIdentidade.atributo.id);                           

                    break;            
                    
                case PaisConstantes.uruguai.codigo:
                    documento = this.getDocuments.filter(d => d.codigoUnico == DocumentoConstantes.uruguai.cedulaIdentidade.codigo);
                    if(documento.length > 0) atributo = documento[0].atributo.filter(a => a.codigoUnico == DocumentoConstantes.uruguai.cedulaIdentidade.atributo.id);                           

                    break;   
                    
                case PaisConstantes.peru.codigo:
                    documento = this.getDocuments.filter(d => d.codigoUnico == DocumentoConstantes.peru.documentoNacionalIdentidade.codigo);
                    if(documento.length > 0) atributo = documento[0].atributo.filter(a => a.codigoUnico == DocumentoConstantes.peru.documentoNacionalIdentidade.atributo.id);                           

                    break;     
                    
                case PaisConstantes.equador.codigo:
                    documento = this.getDocuments.filter(d => d.codigoUnico == DocumentoConstantes.equador.cedulaIdentidade.codigo);
                    if(documento.length > 0) atributo = documento[0].atributo.filter(a => a.codigoUnico == DocumentoConstantes.equador.cedulaIdentidade.atributo.id);                           

                    break;         
                    
                case PaisConstantes.mexico.codigo:
                    documento = this.getDocuments.filter(d => d.codigoUnico == DocumentoConstantes.mexico.chaveUnicaRegistroPopulacao.codigo);
                    if(documento.length > 0) atributo = documento[0].atributo.filter(a => a.codigoUnico == DocumentoConstantes.mexico.chaveUnicaRegistroPopulacao.atributo.id);                           

                    break;
                    
                case PaisConstantes.estadosUnidos.codigo:
                    documento = this.getDocuments.filter(d => d.codigoUnico == DocumentoConstantes.estadosUnidos.socialSecurityNumber.codigo);
                    if(documento.length > 0) atributo = documento[0].atributo.filter(a => a.codigoUnico == DocumentoConstantes.estadosUnidos.socialSecurityNumber.atributo.id);                           
    
                    break; 
                    
                case PaisConstantes.costaRica.codigo:
                    documento = this.getDocuments.filter(d => d.codigoUnico == DocumentoConstantes.costaRica.cedulaIdentidade.codigo);
                    if(documento.length > 0) atributo = documento[0].atributo.filter(a => a.codigoUnico == DocumentoConstantes.costaRica.cedulaIdentidade.atributo.id);                           

                    break;          
                    
                case PaisConstantes.panama.codigo:
                    documento = this.getDocuments.filter(d => d.codigoUnico == DocumentoConstantes.panama.cedulaIdentidade.codigo);
                    if(documento.length > 0) atributo = documento[0].atributo.filter(a => a.codigoUnico == DocumentoConstantes.panama.cedulaIdentidade.atributo.id);                           

                    break;                      
            }

            return atributo;
        },          
        retornarMascaraDocumentoPrincipal(pais) {
            let mascara = "";
            let atributo = this.retornarAtributoDocumentoPrincipal(pais);

            if((atributo || []).length > 0)  mascara = atributo[0].mascaraFormatacao;
            return mascara;
        },        
        formatarDocumentoPrincipal(pais, valor){
            let atributo = this.retornarAtributoDocumentoPrincipal(pais);
            let value = null;

            if((atributo || []).length > 0){
                let mask = atributo[0].mascaraFormatacao;
                if(_.trim(valor) != ""){
                    switch(pais.codigoSuccessFactors){
                        case PaisConstantes.argentina.codigo:
                        case PaisConstantes.equador.codigo:
                        case PaisConstantes.peru.codigo:
                        case PaisConstantes.colombia.codigo:
                            value = String(Number(valor));
                            break;

                        default:
                            value = valor.padLeft(atributo[0].tamanho, "0");
                            value = Masker(value, mask, true, Tokens);

                            break;                            
                    }
                }
            } 

            return value;
        }
    }
}